import styles from '@pages/AppLayout.module.scss';
import React, {useEffect, useState} from "react";
import MainSidebar from "@components/layout/MainSidebar";
import MainHeader from "@components/layout/MainHeader";
import MainFooter from "@components/layout/MainFooter";
import RightSidebar from "@components/layout/RightSidebar";
import FlintNotification from "@components/page_components/common/notifications/FlintNotification";
import {useFlintNotificationContext} from "@components/page_components/common/notifications/FlintNotificationContext";
import {Outlet, useLocation} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons"
import {CommonUtils} from "@utils/CommonUtils";
export default function AppLayout() {
    const {rightSidebar} = useFlintNotificationContext();
    const [wrapperClass, setWrapperClass] = useState(styles.pageWrapper);
    const location = useLocation();
    function handleOverlayClicked(){
        CommonUtils.handleToggleSidebarVisibility(false);
    }
    useEffect(() => {
        // on *any* location change, close the sidebar
        CommonUtils.handleToggleSidebarVisibility(false);
    }, [location]);
    
    useEffect(() => {
        setWrapperClass(rightSidebar?.get.visible ? `${styles.pageWrapper} right-sidebar-open` : `${styles.pageWrapper}`);
    }, [rightSidebar?.get]);

    return (
        <div className={wrapperClass}>
            <MainHeader/>
            <main className="container-fluid px-0">
                <div className={styles.mainWrapper}>
                    <div id="main-sidebar-container" className={styles.mainSidebarContainer}>
                        <div className={styles.mobileSidebarOverlay} onClick={handleOverlayClicked}>
                            <FontAwesomeIcon className={styles.closeButtonIcon} icon={icons.faClose}/>
                        </div>
                        <MainSidebar/>
                    </div>
                    <div className={styles.content}>
                        <div className={styles.mainContent}>
                            <FlintNotification/>
                            <Outlet/>
                            <RightSidebar/>
                        </div>
                        <MainFooter/>
                    </div>
                </div>
                
            </main>
        </div>
    );
}

